import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../Login/style.module.css';
import Logo from '../Login/logowhite.png';
import { validateToken } from '../../../services/kollectaApi';

function maskEmail(email) {
  if (!email) return '';
  const [user, domain] = email.split('@');
  if (!domain) return email; // caso não seja um email válido

  if (user.length <= 2) {
    // Para nomes curtos, mostra só o primeiro caractere e mascara o resto
    return user[0] + '*'.repeat(user.length - 1) + '@' + domain;
  }

  const firstChar = user[0];
  const lastChar = user[user.length - 1];
  const maskedMiddle = '*'.repeat(user.length - 2);

  return firstChar + maskedMiddle + lastChar + '@' + domain;
}


const TokenInputPage = () => {
  const [token, setToken] = useState(['', '', '', '', '']);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState('');
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email');
    if (email) {
      setMaskedEmail(maskEmail(email));
    }
  }, [location.search]);

  const handleTokenChange = (index, value) => {
    if (value.length > 1) return;
    const updatedToken = [...token];
    updatedToken[index] = value.toUpperCase();
    setToken(updatedToken);
    if (value && index < 4) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const updatedToken = [...token];
      if (token[index]) {
        updatedToken[index] = '';
        setToken(updatedToken);
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
        updatedToken[index - 1] = '';
        setToken(updatedToken);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text').toUpperCase().slice(0, 5);
    const updatedToken = [...token];
    for (let i = 0; i < paste.length; i++) {
      updatedToken[i] = paste[i];
      if (inputsRef.current[i]) {
        inputsRef.current[i].value = paste[i];
      }
    }
    setToken(updatedToken);
    const lastIndex = paste.length >= 5 ? 4 : paste.length;
    if (inputsRef.current[lastIndex]) {
      inputsRef.current[lastIndex].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullToken = token.join('');
    if (fullToken.length < 5) {
      setError('Por favor, preencha o token completo.');
      return;
    }
    setLoading(true);
    setError('');
    //
    try {
      // Valida token no backend
      await validateToken({ token: fullToken });
      // Se válido, navega para página de nova senha com token na URL
      navigate(`/reset-password/new?token=${fullToken}`);
    } catch (err) {
      setError(err.response?.data?.message || 'Token inválido ou expirado.');
    }
    setLoading(false);
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.left}>
        <img src={Logo} alt="Logo" />
      </div>
      <div className={styles.right}>
        <form className={styles.cardForm} onSubmit={handleSubmit}>
          <div className={styles.cardFormHeader}>
            <h4 className={styles.textInfo}>Digite seu token</h4>
            <p>
              Digite abaixo o código que enviamos por e-mail para <br />
              <strong>{maskedEmail || 'seu e-mail'}</strong>
            </p>
          </div>
          <div className={styles.inputsContainer}>
            <label className={styles.formItem}>
              Token *
              <div className={styles.tokenInputContainer}>
                {token.map((char, idx) => (
                  <input
                    key={idx}
                    ref={(el) => (inputsRef.current[idx] = el)}
                    type="text"
                    maxLength={1}
                    value={char}
                    onChange={(e) => handleTokenChange(idx, e.target.value)}
                    onKeyDown={(e) => handleBackspace(e, idx)}
                    onPaste={(e) => handlePaste(e)}
                    className={styles.tokenInput}
                  />
                ))}
              </div>
            </label>
          </div>
          <button
            type="submit"
            className={styles.btnSubmit}
            disabled={loading || token.some((char) => char === '')}
          >
            {loading ? 'Validando...' : 'Continuar'}
          </button>
          {error && (
            <div className={styles.errorMessage}>
              <small>{error}</small>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default TokenInputPage;
